import styled from 'styled-components';

export const InfoContainer = styled.div`
  display: flex;
  & > div:first-child {
    margin-right: 80px;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
`;

export const WorkingHoursBlock = styled.div`
  & > div:first-child {
    margin-bottom: 14px;
  }
`;
